import { cssBundleHref } from '@remix-run/css-bundle';
import { useRouteError } from '@remix-run/react';
import { captureRemixErrorBoundaryError } from '@sentry/remix';
import { Logger } from '@tectonic/logger';
import { RootApp } from '@tectonic/remix-core';
import { generateTWColors } from '@tectonic/utils';
import { colors } from '../colors';
import routes from '../routes.json';
import mainCss from './styles/main.css';

import type { LinksFunction } from '@remix-run/node';

const links: LinksFunction = () => [
...(cssBundleHref ? [{ rel: 'stylesheet', href: cssBundleHref }] : [])];


const App = () =>
<RootApp
  routes={routes}
  cssHref={mainCss}
  colors={generateTWColors(colors)}
  title="Jennyfer : Vêtements Femme, Ado et Fille"
  description="Découvre toutes les tendances ✨Jennyfer, collabs, basiques à prix canon pour Femme, Ado et Fille. 📦Livraison gratuite dès 5€ en Mag, paiement en 3x sans frais💖" />;



export { rootLoader as loader } from '@tectonic/remix-core';
export { links };

export const ErrorBoundary = () => {
  const error = useRouteError();
  captureRemixErrorBoundaryError(error);
  Logger.error(error);
  return <div>Something went wrong</div>;
};

export default App;